"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidCrefoPassword = exports.MAX_PASSWORD_LENGTH = exports.MIN_PASSWORD_LENGTH = void 0;
exports.MIN_PASSWORD_LENGTH = 10;
exports.MAX_PASSWORD_LENGTH = 60;
/**
 * TypeDef PasswordPolicyValidationResult
 *
 * @typedef {Object} PasswordPolicyValidationResult
 * @property {boolean} valid
 * @property {IPasswordPolicyValidationChecks} checks
 */
/**
 * Prüft, ob der Eingabewert der Komplexität der [allgemeinen Creditreform Passwort Richtlinie](https://confluence.creditreform.de/pages/viewpage.action?spaceKey=CPSSO&title=Passwort-+und+Anmelde-Richtlinien)
 * entspricht.
 *
 * @param {string} str Input string to be matched against the password policy
 * @returns {PasswordPolicyValidationResult} Returns a `PasswordPolicyValidationResult`
 */
var isValidCrefoPassword = function (str) {
    var result = {
        valid: false,
        checks: {
            type: false,
            length: false,
            upper: false,
            lower: false,
            digit: false,
            specialChars: false,
            validChars: false,
        },
    };
    // Korrekter Type?
    if (str !== null && typeof str === 'string') {
        result.checks.type = true;
    }
    else {
        return result;
    }
    // 1. Das Passwort muss aus mindestens zehn und maximal 60 Zeichen bestehen.
    if (str.length && str.length >= exports.MIN_PASSWORD_LENGTH && str.length <= exports.MAX_PASSWORD_LENGTH) {
        result.checks.length = true;
    }
    var regExp_Upper_AZ = /[A-Z]/;
    var regExp_Upper_Diacrit = /[ÄÖÜÊÉÈËÁÀÆÔÒÛÙŒÇÎÏ]/;
    var regExp_Lower_az = /[a-z]/;
    var regExp_Lower_Diacrit = /[ßäöüêéèëáàæôòûùœçîï]/;
    var regExp_Digits = /\d/;
    var regExp_SpecialChars = /[!"#$%&'()*+,-./:;<=>?[\\_\]^`{|}~]/;
    var regExp_ValidChars = /^[A-Za-z0-9ÄÖÜÊÉÈËÁÀÆÔÒÛÙŒÇÎÏßäöüêéèëáàæôòûùœçîï!"#$%&'()*+,-./:;<=>?[\\_\]^`{|}~]+$/;
    // 2.1 Das Passwort muss mindestens einen Großbuchstaben A-Z (inkl. diakritischer (DE & FR) Zeichen) enthalten.
    if (regExp_Upper_AZ.test(str)) {
        result.checks.upper = true;
    }
    else if (regExp_Upper_Diacrit.test(str)) {
        result.checks.upper = true;
    }
    // 2.2 Das Passwort muss mindestens einen Kleinbuchstaben a-z (inkl. diakritischer (DE & FR) Zeichen) enthalten.
    if (regExp_Lower_az.test(str)) {
        result.checks.lower = true;
    }
    else if (regExp_Lower_Diacrit.test(str)) {
        result.checks.lower = true;
    }
    // 3.1 Das Passwort muss mindestens eine Ziffer 0-9 enthalten. ODER 3.2
    if (regExp_Digits.test(str)) {
        result.checks.digit = true;
    }
    // 3.2 Das Passwort muss mindestens ein Sonderzeichen enthalten.
    // Die Liste der Sonderzeichen orientiert sich an den druckbaren Sonderzeichen in ANSI X3.4-1986 ohne Whitespaces:
    // `! " # $ % & ' ( ) * + , - . / : ; < = > ? [ \ _ ] ^ ` { | } ~`
    if (regExp_SpecialChars.test(str)) {
        result.checks.specialChars = true;
    }
    // Es dürfen nur die zugelassene Zeichen enthalten sein
    if (regExp_ValidChars.test(str)) {
        result.checks.validChars = true;
    }
    if (result.checks.type &&
        result.checks.length &&
        result.checks.upper &&
        result.checks.lower &&
        (result.checks.digit || result.checks.specialChars) &&
        result.checks.validChars) {
        result.valid = true;
    }
    return result;
};
exports.isValidCrefoPassword = isValidCrefoPassword;
